import { BoxProps } from '@mui/material';
import { CommonDialogProps } from '@app/types/common';
import { useRef, useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetDragIndicatorLeft,
  SheetDragIndicatorRight,
  SheetHeaderWrapper,
} from './BottomSheetStyle';

interface SheetHeaderProps extends BoxProps {
  isDragged: boolean;
}

interface BottomSheetProps extends CommonDialogProps {}

function SheetHeader({ isDragged }: SheetHeaderProps) {
  return (
    <SheetHeaderWrapper className='sheet-header handle'>
      <SheetDragIndicatorLeft
        isDragged={isDragged}
        className='sheet-drag-indicator-left'
      ></SheetDragIndicatorLeft>
      <SheetDragIndicatorRight
        isDragged={isDragged}
        className='sheet-drag-indicator-right'
      ></SheetDragIndicatorRight>
    </SheetHeaderWrapper>
  );
}

function BottomSheet({ children, isOpen, onClose, onOpen = () => {} }: BottomSheetProps) {
  const [isDragged, setIsDragged] = useState<boolean>(false);

  const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

  const ref = useRef(null);
  const currentY = useRef<number | undefined>(undefined);

  const onTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!currentY.current) {
      currentY.current = e.touches[0].clientY;
    }
    const shouldSetIsDragged =
      currentY.current && e.touches[0].clientY - currentY.current > 0 && !isDragged;
    if (shouldSetIsDragged) {
      setIsDragged(true);
    }
  };

  const onTouchEnd = () => {
    currentY.current = undefined;
    setIsDragged(false);
  };

  return (
    <>
      {isOpen && (
        <Sheet
          anchor={'bottom'}
          open={isOpen}
          onClose={onClose}
          onOpen={onOpen}
          disableBackdropTransition={!iOS}
          disableDiscovery={iOS}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          ref={ref}
        >
          <SheetHeader isDragged={isDragged}></SheetHeader>
          <SheetContent>{children}</SheetContent>
        </Sheet>
      )}
    </>
  );
}

export default BottomSheet;
